export const SEND_UPLOAD_OFFER_EMAIL = 'SEND_UPLOAD_OFFER_EMAIL'
export const SEND_UPLOAD_OFFER_EMAIL_SUCCESS = 'SEND_UPLOAD_OFFER_EMAIL_SUCCESS'
export const SEND_UPLOAD_OFFER_EMAIL_FAIL = 'SEND_UPLOAD_OFFER_EMAIL_FAIL'
